export default {"src":"/_next/static/media/pair-1.0d6ae3d9.svg","height":280,"width":452,"blurWidth":0,"blurHeight":0};